import { Severity } from '@sentry/types';
import { HttpError } from '@wix/http-client';

type LogParams = {
  error: Error;
  message: string;
  callParams?: Record<string, any>;
};

type LogWidgetMessageParams = {
  payload: Record<string, any>;
  widgetEventType: string;
};

enum SentryTags {
  ORIGIN = 'origin',
}

enum MessageOrigins {
  WIDGET = 'widget',
  CLIENT = 'client',
}

class Logger {
  log({ error, message, callParams = {} }: LogParams): void {
    try {
      window.Sentry.withScope((scope) => {
        const localError = new Error(message);
        scope.setExtra('originalError', error.message);
        scope.setExtra('originalErrorStack', error.stack);
        scope.setExtra('callParams', JSON.stringify(callParams));

        if (error instanceof HttpError) {
          const { status, statusText, data, headers } = error.response;
          scope.setExtra('httpErrorStatus', status);
          scope.setExtra('httpErrorStatusText', statusText);
          scope.setExtra('httpErrorData', data);
          scope.setExtra('X-Wix-Request-Id', headers['x-wix-request-id']);
        }

        scope.setTag(SentryTags.ORIGIN, MessageOrigins.CLIENT);
        window.Sentry.captureException(localError);
      });
    } catch (e) {}
  }

  logWidgetMessage({ widgetEventType, payload }: LogWidgetMessageParams): void {
    window.Sentry.withScope((scope) => {
      scope.setTag(SentryTags.ORIGIN, MessageOrigins.WIDGET);
      scope.setExtra('eventParams', JSON.stringify(payload));
      window.Sentry.captureMessage(widgetEventType, Severity.Info);
    });
  }

  debug(debug?: string[]) {
    if (Array.isArray(debug) && debug.length > 0) {
      console.log.apply(null, debug);
    }
  }
}

export const logger = new Logger();
